/**
 * Options for the "New partner" drawer used on /group/partners and /tpo/partners.
 * The values match the server's PartnerType / Industry / CompanySize enums exactly.
 */

export const PARTNER_TYPE_OPTIONS: Array<[string, string]> = [
  ['Product_Company', 'Product company'],
  ['Service_Company', 'Service company'],
  ['Startup', 'Startup'],
  ['Consulting_Firm', 'Consulting firm'],
  ['Training_Provider', 'Training provider'],
  ['Placement_Partner', 'Placement partner'],
  ['Internship_Provider', 'Internship provider'],
  ['R&D_Lab', 'R&D lab'],
  ['NGO', 'NGO'],
  ['Government_Agency', 'Government agency'],
  ['Other', 'Other'],
];

export const INDUSTRY_OPTIONS: Array<[string, string]> = [
  ['', 'Not specified'],
  ['IT_Software', 'IT — software'],
  ['IT_Services', 'IT — services'],
  ['Consulting', 'Consulting'],
  ['Finance_Banking', 'Finance & banking'],
  ['Manufacturing', 'Manufacturing'],
  ['Healthcare', 'Healthcare'],
  ['Education', 'Education'],
  ['E-Commerce', 'E-commerce'],
  ['Automotive', 'Automotive'],
  ['Aerospace', 'Aerospace'],
  ['Telecom', 'Telecom'],
  ['Media_Entertainment', 'Media & entertainment'],
  ['Government', 'Government'],
  ['Non_Profit', 'Non-profit'],
  ['Other', 'Other'],
];

export const COMPANY_SIZE_OPTIONS: Array<[string, string]> = [
  ['', 'Not specified'],
  ['Startup', 'Startup (<50)'],
  ['SME', 'SME (50–500)'],
  ['Enterprise', 'Enterprise (500–5000)'],
  ['MNC', 'MNC (5000+)'],
  ['Government', 'Government'],
];

/**
 * Partner types with a full portal experience in the pilot. Others land on ComingSoon.
 */
export const HIRING_PARTNER_TYPES = new Set<string>([
  'Product_Company', 'Service_Company', 'Consulting_Firm', 'Startup',
]);

export function isHiringPartnerType(type?: string): boolean {
  return !!type && HIRING_PARTNER_TYPES.has(type);
}

export const PARTNER_INVITE_ROLE_OPTIONS: Array<[string, string]> = [
  ['partner_admin', 'Partner admin'],
  ['recruiter', 'Recruiter'],
  ['hiring_manager', 'Hiring manager'],
  ['partner_accountant', 'Accountant'],
  ['technical_panel', 'Technical panel'],
];
